<template>
  <header id="header" v-if="this.show">

    <div id="logo" @click="goIndex" title="Domů.">
      <svg xmlns="http://www.w3.org/2000/svg" width="251.035" height="126.01" viewBox="0 0 251.035 126.01">
        <g transform="translate(0.017 0.022)">
          <path
              d="M553.614,294.557v54.767H499.62a53.611,53.611,0,0,1-28.834-8.36l-.814-.5v9.018H442.3V307.02H403.517V349.48H370.7l-40.408-52.948V349.48H302.614V243.313h27.673v48.071l35.106-48.071h38.124v38.743H442.3V243.313h27.673V250.2l1.277-.812a54.022,54.022,0,0,1,80.312,31.2l.387,1.471H525.475l-.425-.812-.465-.774a29.052,29.052,0,0,0-49.271-1.046l-.5.775-.464.774a29.08,29.08,0,0,0,23.416,43.349l.929.077h.929V294.557h53.994v1.587m-177.77,17.069V273.347L361.02,293.822l14.824,19.391"
              transform="translate(-302.614 -241.335)" stroke="#000" stroke-linecap="round" stroke-linejoin="round"
              stroke-width="0.035"/>
          <path
              d="M310.135,356.1l-4.463-5.851V356.1h-3.058V344.367h3.058v5.316l3.876-5.316H313.1l-4.035,5.583,4.693,6.153Z"
              transform="translate(-302.614 -230.327)"/>
          <path
              d="M320.677,355.145h-4.214l-.427.978h-3.289l5.335-11.949h.977l5.334,11.949H321.1Zm-2.1-5.174-1.03,2.721h2.044Z"
              transform="translate(-301.531 -230.348)"/>
          <path d="M332.355,347.123h-3.521v8.98h-3.058v-8.98h-3.521v-2.756h10.1Z"
                transform="translate(-300.516 -230.327)"/>
          <path d="M340.742,347.123h-5.085v1.618h3.627v2.56h-3.627v2.044h5.3V356.1H332.6V344.367h8.143Z"
                transform="translate(-299.41 -230.327)"/>
          <path
              d="M344.4,343.657l-2.649-3.306h2.293l1.369,1.138,1.369-1.138H349.1l-2.651,3.306Zm4.445,12.875-2.649-3.646h-1.263v3.646h-3.058V344.8h4.606c2.578,0,4.534,1.546,4.534,4.036a3.8,3.8,0,0,1-1.85,3.344l3.094,4.357Zm-3.912-6.313H346.5a1.378,1.378,0,1,0,0-2.755h-1.565Z"
              transform="translate(-298.432 -230.756)"/>
          <path d="M355.394,356.1h-3.057V344.367h3.057Z" transform="translate(-297.302 -230.327)"/>
          <path d="M367.621,344.388v11.948h-.978l-6.367-6.171v5.958h-3.057V344.174h.977l6.367,6.081v-5.867Z"
                transform="translate(-296.78 -230.348)"/>
          <path
              d="M375.637,355.145h-4.215l-.426.978h-3.29l5.334-11.949h.977l5.335,11.949h-3.29Zm-2.1-5.174-1.032,2.721h2.044Z"
              transform="translate(-295.66 -230.348)"/>
          <path d="M393.413,356.1h-3.058v-4.7h-4.286v4.7h-3.058V344.367h3.058v4.285h4.286v-4.285h3.058Z"
                transform="translate(-294.024 -230.327)"/>
          <path
              d="M406.641,350.255a6.336,6.336,0,1,1-6.349-6.081A6.151,6.151,0,0,1,406.641,350.255Zm-9.531,0a3.062,3.062,0,0,0,3.2,3.272,3.273,3.273,0,1,0-3.2-3.272Z"
              transform="translate(-292.853 -230.348)"/>
          <path
              d="M413.959,356.1l-2.649-3.646h-1.263V356.1h-3.058V344.367h4.606c2.578,0,4.534,1.546,4.534,4.035a3.8,3.8,0,0,1-1.85,3.344l3.094,4.357Zm-3.912-6.313h1.565a1.378,1.378,0,1,0,0-2.755h-1.565Z"
              transform="translate(-291.463 -230.327)"/>
          <path
              d="M424.362,355.553h-4.214l-.427.978h-3.289l5.335-11.949h.977l5.334,11.949H424.79Zm-1.1-11.9h-2.2l1.139-3.306h3.68v.532Zm-1,6.722-1.03,2.721h2.044Z"
              transform="translate(-290.454 -230.756)"/>
          <path
              d="M435.566,356.1l-4.464-5.851V356.1h-3.058V344.367H431.1v5.316l3.877-5.316h3.556L434.5,349.95l4.694,6.153Z"
              transform="translate(-289.213 -230.327)"/>
          <path
              d="M454.589,346.787l-2.133,1.814a3.453,3.453,0,0,0-2.97-1.618,3.034,3.034,0,0,0-3.2,3.272,3.16,3.16,0,0,0,3.378,3.36,3.3,3.3,0,0,0,2.579-1.049v-.55H449.5v-2.632h5.8v3.7a6.529,6.529,0,0,1-5.761,3.254,6.088,6.088,0,1,1,0-12.162A5.869,5.869,0,0,1,454.589,346.787Z"
              transform="translate(-287.599 -230.348)"/>
          <path
              d="M467.814,350.255a6.335,6.335,0,1,1-6.349-6.081A6.151,6.151,0,0,1,467.814,350.255Zm-9.531,0a3.062,3.062,0,0,0,3.2,3.272,3.273,3.273,0,1,0-3.2-3.272Z"
              transform="translate(-286.317 -230.348)"/>
          <path
              d="M475.132,356.1l-2.649-3.646H471.22V356.1h-3.058V344.367h4.606c2.579,0,4.535,1.546,4.535,4.035a3.8,3.8,0,0,1-1.85,3.344l3.094,4.357Zm-3.912-6.313h1.566a1.378,1.378,0,1,0,0-2.755H471.22Z"
              transform="translate(-284.927 -230.327)"/>
          <path d="M484.138,351.6v4.5h-3.058v-4.464l-4.035-7.272h3.378l2.187,4.09,2.187-4.09h3.36Z"
                transform="translate(-283.978 -230.327)"/>
          <path
              d="M498.863,347.321l-2.329,1.583a3.4,3.4,0,0,0-3.058-1.92,3.273,3.273,0,0,0,0,6.544,3.4,3.4,0,0,0,3.058-1.92l2.329,1.583a5.908,5.908,0,0,1-5.387,3.147,6.086,6.086,0,1,1,.018-12.162A5.9,5.9,0,0,1,498.863,347.321Z"
              transform="translate(-282.899 -230.348)"/>
          <path d="M508.251,353.346V356.1h-9.815v-.8l5.139-8.178H499.2v-2.756h9.033v.8l-5.157,8.178Z"
                transform="translate(-281.693 -230.327)"/>
          <path
              d="M516.252,356.1l-4.464-5.851V356.1H508.73V344.367h3.058v5.316l3.877-5.316h3.555l-4.036,5.583,4.694,6.153Z"
              transform="translate(-280.593 -230.327)"/>
          <path
              d="M526.793,355.145H522.58l-.426.978h-3.289l5.334-11.949h.977l5.335,11.949h-3.289Zm-2.1-5.174-1.031,2.721h2.044Z"
              transform="translate(-279.51 -230.348)"/>
        </g>
      </svg>
    </div>
    <TheMenu />
  </header>
</template>
<script>
import TheMenu from "@/components/TheMenu.vue";

export default {
  name: "theHeader",
  components: {
    TheMenu
  },
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    goIndex() {
      this.$router.push({
        name: 'index'
      });
    }
  }
};
</script>
